import axios from "axios";

export const url = "https://uveos.ficom-it.ru/api1.0/request.php";

export async function LogIn(login, password) {
  let response = await axios({
    method: "POST",
    url: url,
    data: {
      info: {
        apiVersion: "1.0",
        uuid: "",
        deviceId: "",
        timestamp: new Date().toISOString(),
        lang: "ru",
        session: "",
        email: login,
      },
      name: "LogIn",
      data: {
        password: password,
      },
    },
  });
  return response;
}

export async function LogOut(token, login) {
  let response = await axios({
    method: "POST",
    url: url,
    data: {
      info: {
        apiVersion: "1.0",
        uuid: "",
        deviceId: "",
        timestamp: new Date().toISOString(),
        lang: "ru",
        session: token,
        email: login,
      },
      name: "LogOut",
      data: {},
    },
  });
  return response;
}

export async function GetDevice(
  token,
  login,
  limit,
  offset,
  type,
  status_id,
  search_str,
  startdate,
  enddate
) {
  let response = await axios({
    method: "POST",
    url: url,
    data: {
      info: {
        apiVersion: "1.0",
        uuid: "",
        deviceId: "",
        timestamp: new Date().toISOString(),
        lang: "ru",
        session: token,
        email: login,
      },
      name: "GetDevice",
      data: {
        type: type,
        limit: limit,
        offset: offset,
        status_id: status_id,
        search_str: search_str,
        startdate: startdate,
        enddate: enddate,
      },
    },
  });
  return response;
}

export async function GetTestDevice(token, login, id_device) {
  let response = await axios({
    method: "POST",
    url: url,
    data: {
      info: {
        apiVersion: "1.0",
        uuid: "",
        deviceId: "",
        timestamp: new Date().toISOString(),
        lang: "ru",
        session: token,
        email: login,
      },
      name: "GetTestDevice",
      data: {
        uid: id_device,
      },
    },
  });
  return response;
}

export async function GetStatusDevice(token, login) {
  let response = await axios({
    method: "POST",
    url: url,
    data: {
      info: {
        apiVersion: "1.0",
        uuid: "",
        deviceId: "",
        timestamp: new Date().toISOString(),
        lang: "ru",
        session: token,
        email: login,
      },
      name: "GetStatusDevice",
      data: {},
    },
  });
  return response;
}

export async function GetUser(token, login) {
  let response = await axios({
    method: "POST",
    url: url,
    data: {
      info: {
        apiVersion: "1.0",
        uuid: "",
        deviceId: "",
        timestamp: new Date().toISOString(),
        lang: "ru",
        session: token,
        email: login,
      },
      name: "GetUser",
      data: {},
    },
  });
  return response;
}

export async function GetUsers(token, login) {
  let response = await axios({
    method: "POST",
    url: url,
    data: {
      info: {
        apiVersion: "1.0",
        uuid: "",
        deviceId: "",
        timestamp: new Date().toISOString(),
        lang: "ru",
        session: token,
        email: login,
      },
      name: "GetUsers",
      data: {},
    },
  });
  return response;
}

export async function CreateUser(token, login, data) {
  let response = await axios({
    method: "POST",
    url: url,
    data: {
      info: {
        apiVersion: "1.0",
        uuid: "",
        deviceId: "",
        timestamp: new Date().toISOString(),
        lang: "ru",
        session: token,
        email: login,
      },
      name: "CreateUser",
      data: {
        email: data.email,
        password: data.password,
        roles_id: data.roles_id,
        name: data.name,
        surname: data.surname,
      },
    },
  });
  return response;
}

export async function DeleteUser(token, login, id) {
  let response = await axios({
    method: "POST",
    url: url,
    data: {
      info: {
        apiVersion: "1.0",
        uuid: "",
        deviceId: "",
        timestamp: new Date().toISOString(),
        lang: "ru",
        session: token,
        email: login,
      },
      name: "DeleteUser",
      data: {
        id: id,
      },
    },
  });
  return response;
}
